var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "neopass_form_portfolio"
    }
  }, [_c('media-manager-popup', {
    ref: "mediaManager",
    attrs: {
      "data-to-show": _vm.isAddNewPopupDisplayed,
      "categories": _vm.categories
    },
    on: {
      "close": function ($event) {
        _vm.isAddNewPopupDisplayed = false;
      },
      "newMedia": _vm.getMedias
    }
  }), _vm._v(" "), _c('preview-media', {
    attrs: {
      "data-to-show": _vm.isPreviewPopupDisplayed,
      "file": _vm.mediaToDisplay
    },
    on: {
      "close": function ($event) {
        return _vm.displayPopupPreview(false);
      }
    }
  }), _vm._v(" "), _c('edit-category-popup', {
    ref: "editCategoryPopup",
    attrs: {
      "data-to-show": _vm.isEditCategoryPopupDisplayed,
      "old-category": _vm.categoryToEdit,
      "errors": {}
    },
    on: {
      "editCategory": function (newCategory) {
        _vm.editCategory(newCategory);
      },
      "close": function ($event) {
        return _vm.closeEditCategoryPopup();
      }
    }
  }), _vm._v(" "), _c('delete-category-popup', {
    attrs: {
      "category": _vm.categoryToEdit,
      "data-to-show": _vm.isDeleteCategoryPopupDisplayed
    },
    on: {
      "deleteCategory": function (category) {
        _vm.deleteCategory(category);
      },
      "close": function ($event) {
        return _vm.closeDeleteCategoryPopup();
      }
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "mx-5 mt-5 mb-15 md:mx-15 md:mt-15 2xl:mx-20 2xl:mt-20 2xl:mb-20"
  }, [_vm._v("\n    Portfolio\n  ")]), _vm._v(" "), _vm.listMedias.length > 0 ? _c('div', {
    staticClass: "m-5 lg:m-15 relative",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.hideCategoryMenu.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "flex justify-center items-center mb-20 pb-5"
  }, [_c('ul', {
    staticClass: "flex justify-between md:justify-center md:space-x-10 overflow-x-auto text-2xl w-2/3 md:w-full no-scroll-bar"
  }, [_c('li', {
    staticClass: "flex-shrink-0 inline-block cursor-pointer duration-300 transition-colors hover:text-indigo-600 hover:font-normal",
    class: {
      'text-gray-600 font-light': _vm.categoriesFilter != '',
      'text-pink-600 font-normal': _vm.categoriesFilter == ''
    },
    on: {
      "click": function ($event) {
        _vm.categoriesFilter = '';
        _vm.numPage = 1;
      }
    }
  }, [_vm._v("\n          Toutes\n        ")]), _vm._v(" "), _vm._l(_vm.categories, function (cat, i) {
    return _c('li', {
      key: 'A' + i,
      staticClass: "flex-shrink-0 flex items-center cursor-pointer duration-300 transition-colors hover:text-indigo-600 hover:font-normal pl-4 md:pl-0",
      class: {
        'text-gray-600 font-light': _vm.categoriesFilter != cat,
        'text-pink-600 font-normal': _vm.categoriesFilter == cat
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          _vm.categoriesFilter = cat;
          _vm.numPage = 1;
        }
      }
    }, [_vm._v("\n          " + _vm._s(cat) + "\n          "), _vm.canEditPortfolio ? _c('span', {
      staticClass: "group-hover:block text-pink-600",
      class: {
        'block': _vm.numCategoryMenuDisplayed === i || _vm.categoriesFilter === cat,
        'hidden': _vm.numCategoryMenuDisplayed != i && _vm.categoriesFilter != cat
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.showCategoryMenu(i);
        }
      }
    }, [_c('icon', {
      staticClass: "w-5",
      attrs: {
        "name": "more-vertical"
      }
    })], 1) : _vm._e(), _vm._v(" "), _vm.numCategoryMenuDisplayed == i ? _c('div', {
      staticClass: "absolute rounded-xl bg-white text-gray-600 shadow-lg shadow-gray-600 text-sm w-max max-w-full lg:max-w-128 p-5 top-8 right-8 flex flex-col space-y-2 z-10"
    }, [_c('div', {
      staticClass: "hover:text-gray-900",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.displayEditCategoryPopup(cat);
        }
      }
    }, [_vm._v("\n              Modifier\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "hover:text-gray-900",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.displayDeleteCategoryPopup(cat);
        }
      }
    }, [_vm._v("\n              Supprimer\n            ")])]) : _vm._e()]);
  })], 2), _vm._v(" "), _c('icon', {
    staticClass: "ml-3 text-indigo-600 md:hidden block",
    attrs: {
      "name": "arrow-right_1"
    }
  })], 1), _vm._v(" "), _c('add-button', {
    staticClass: "relative",
    attrs: {
      "libelle": "Ajouter un média"
    },
    on: {
      "add": _vm.openAddNewMediaPopup
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-15 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-2 xxl:grid-cols-3 gap-y-15 lg:gap-x-15 z-10"
  }, _vm._l(_vm.displayedMedias, function (media, i) {
    return _c('media-card', {
      key: i,
      staticClass: "justify-self-center",
      attrs: {
        "file": media,
        "editable": _vm.canEditPortfolio,
        "id": i
      },
      on: {
        "openFile": function ($event) {
          return _vm.showMedia(media);
        },
        "deleteFile": function ($event) {
          return _vm.deleteMedia(media);
        },
        "editFile": function ($event) {
          return _vm.openMediaModifyPopup(media);
        }
      }
    });
  }), 1), _vm._v(" "), _vm.numPage > 0 || _vm.numPage < _vm.pageCount - 1 ? _c('div', {
    staticClass: "w-full mt-15 flex justify-center items-center space-x-2"
  }, [_c('div', {
    staticClass: "cursor-pointer text-gray-600",
    class: {
      'text-indigo-600': _vm.numPage > 1
    },
    on: {
      "click": _vm.prevPage
    }
  }, [_c('icon', {
    staticClass: "h-4 w-3 mr-2",
    attrs: {
      "name": "chevron-left"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-2xl text-gray-600 flex"
  }, [_c('div', {
    class: {
      'text-indigo-600': _vm.numPage > 1
    }
  }, [_vm._v("\n          " + _vm._s(_vm.numPage) + "\n        ")]), _vm._v(" "), _c('div', [_vm._v("/")]), _vm._v(" "), _c('div', {
    class: {
      'text-indigo-600': _vm.numPage < _vm.pageCount
    }
  }, [_vm._v("\n          " + _vm._s(_vm.pageCount) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "cursor-pointer text-gray-600",
    class: {
      'text-indigo-600': _vm.numPage < _vm.pageCount
    },
    on: {
      "click": _vm.nextPage
    }
  }, [_c('icon', {
    staticClass: "h-4 w-3 ml-2",
    attrs: {
      "name": "chevron-right"
    }
  })], 1)]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.listMedias.length == 0 ? _c('div', [_c('div', {
    staticClass: "text-gray-600 flex flex-col space-y-2 text-center mb-10"
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.user.id == _vm.infosPass.id_pass ? "Votre" : "Le"))]), _vm._v(" portfolio est vide\n      ")]), _vm._v(" "), _vm.canEditPortfolio ? _c('p', [_vm._v("\n        commencez par déposer votre premier média.\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col items-center space-y-15"
  }, [_vm.canEditPortfolio ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-indigo-600",
      "bg-color-square": "bg-indigo-600",
      "icon-color": "text-white",
      "libelle": "DÉPOSER UN Média",
      "uppercase": true,
      "icon": "file-add",
      "type-shadow": "indigo-shadow"
    },
    on: {
      "clickAction": _vm.openAddNewMediaPopup
    }
  }) : _vm._e(), _vm._v(" "), _c('illustration', {
    attrs: {
      "name": "evaluation"
    }
  })], 1)]) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }